import { combineReducers } from '@reduxjs/toolkit'
import globalReducer from "./globalReducer"
import reConstructionMaterialReducer from '../../containers/NRI/ReConstructionMaterial/store/reducer'
import reRegionReducer from '../../containers/NRI/ReRegion/store/reducer'
import reDistrictReducer from '../../containers/NRI/ReDistrict/store/reducer'
import reCityReducer from '../../containers/NRI/ReCity/store/reducer'
import reZoneReducer from '../../containers/NRI/ReZone/store/reducer'
import reOrgReducer from '../../containers/NRI/ReOrgs/store/reducer'
import reMeasurementUnitReducer from '../../containers/NRI/ReMeasurementUnit/store/reducer'
import rePriceCalculationTypeReducer from '../../containers/NRI/RePriceCalculationType/store/reducer'
import reConstructionCategoryReducer from '../../containers/NRI/ReConstructionCategory/store/reducer'
import rePossibleCharacteristicReducer from '../../containers/NRI/RePossibleCharacteristic/store/reducer'
import reCharacteristicReducer from '../../containers/NRI/ReCharacteristic/store/reducer'
import reOrgStatusTypeReducer from '../../containers/NRI/ReOrgStatusType/store/reducer'
import reOrgTypeReducer from '../../containers/NRI/ReOrgType/store/reducer'
import reMessageToAdminTypeReducer from '../../containers/NRI/ReMessageToAdminTypes/store/reducer'
import helpSectionReducer from '../../containers/HelpSection/store/reducer'
import newsReducer from '../../containers/News/store/reducer'
import operatorControlReducer from '../../containers/OperatorControl/store/reducer'
import paidUserControlReducer from '../../containers/PaidUserControl/store/reducer'
import messageToAdminReducer from '../../containers/MessageToAdmin/store/reducer'
import rePtmReducer from '../../containers/NRI/RePTMs/store/reducer'
import referenceUnitReducer from '../../containers/NRI/ReReferenceUnits/store/reducer'
import projectReducer from '../../containers/ProjectLibrary/store/reducer'
import userReducer from './user'
import reObjectFunctionTypeReducer from '../../containers/NRI/ReObjectFunctionTypes/store/reducer'
import reCorrectionFactorReducer from "../../containers/NRI/ReCorrectionFactor/store/reducer"
import reBuildTypeReducer from '../../containers/NRI/ReBuildType/store/reducer'
import tarifManagmentReducer from "../../containers/TarifManagment/store/reducer";
import predictivePriceReducer from "../../containers/NRI/PredictivePrice/store/reducer"
import tariffRateReducer from "../../containers/NRI/TariffRate/store/reducer"
import reOzsFormReducer from '../../containers/Account/ManageOzsForms/ReOzsFormManage/store/reducer'
import reConstructionMaterialPeriodPriceReducer from '../../containers/PriceChanges/ReConstructionMaterialPeriodPrices/store/reducer'
import accountingPeriodReducer from '../../containers/PriceChanges/AccountingPeriod/store/reducer'


export default combineReducers({
	globalReducer,
	reConstructionMaterialReducer,
	reRegionReducer,
	reDistrictReducer,
	reCityReducer,
	reZoneReducer,
	reOrgReducer,
	reMeasurementUnitReducer,
	rePriceCalculationTypeReducer,
	reConstructionCategoryReducer,
	rePossibleCharacteristicReducer,
	reCharacteristicReducer,
	reOrgStatusTypeReducer,
	reOrgTypeReducer,
	reMessageToAdminTypeReducer,
	helpSectionReducer,
	newsReducer,
	operatorControlReducer,
	paidUserControlReducer,
	messageToAdminReducer,
	rePtmReducer,
	referenceUnitReducer,
	userReducer,
	projectReducer,
	reObjectFunctionTypeReducer,
	reCorrectionFactorReducer,
	reBuildTypeReducer,
	tarifManagmentReducer,
	predictivePriceReducer,
	tariffRateReducer,
	reOzsFormReducer,
	reConstructionMaterialPeriodPriceReducer,
	accountingPeriodReducer
})
